import React, {useState, useEffect} from 'react';
import { Route, Routes } from 'react-router-dom';
import AppContext from './components/AppContext';
import Cookies from 'js-cookie';

import Home from './pages/Home.js';
import DashBoard from './pages/Dashboard/DashBoard.js';
import AssetList from './pages/Asset/AssetList.js';
// import AssetList2 from './pages/AssetAgGrid/AssetList.js';
import AssetTable from './pages/Asset/AssetTable.js';
import AssetUpload from './pages/Asset/AssetUpload.js';
import AnalysisList from './pages/Analysis/AnalysisList.js';
import AnalysisCreate from './pages/Analysis/AnalysisCreate.js';
import AnalysisInfo from './pages/AnalysisInfo/AnalysisInfo';
import AnalysisResult from './pages/Analysis/AnalysisResult.js';
import AnalysisResultPop from './pages/Analysis/AnalysisResultPop.js';
import AnalysisRefDetail from './pages/Analysis/AnalysisRefDetail.js';
import AnalysisListBox from './pages/TotalReport/AnalysisListBox.js';
import AnalysisListCompare from './pages/TotalReport/AnalysisListCompare.js';
import Vulnerablity from './pages/Vulnerablity/Vulnerablity.js';
import RiskReport from './pages/RiskReport/RiskReport.js';
import RiskManagement from './pages/RiskManagement/RiskManagement.js';
import ImplementReport from './pages/ImplementReport/ImplementReport';
import ImplementResult from './pages/ImplementResult/ImplementResult.js';
import AssetReport from './pages/AssetReport/AssetReport.js';
import TemplateList from './pages/Template/TemplateList.js';
import TemplateInfo from './pages/Template/TemplateInfo.js';
import TemplateCreate from './pages/Template/TemplateCreate.js';
import LogList from './pages/Common/LogList.js';
import LoginForm from './components/LoginForm.js';
import OtpSetup from './components/OtpSetup.js';
import HelpManual from './pages/help/Manual.js';
import HelpAssetCommonCode from './pages/help/AssetCommonCode.js';
import ConfigValue from './pages/ConfigValue/configValue.js';
import RiskManual from './pages/help/RiskManual.js';
import SecureManual from './pages/help/SecureManual.js';
import AnalysisHtmlx from './pages/Analysis/AnalysisHtmx.js';
import Test from './pages/help/Test.js';
import ReportsList from './pages/Reports/ReportsList.js';


const App = () => {

  // 쿠키에서 인증 토큰 값 가져오기
  const authToken = Cookies.get('access_token');
  // 인증 토큰 값이 존재하면 로그인된 상태로 처리
  const authenticated = authToken?true:false;

  // 변수 선언
  const [companyCode, setCompanyCode] = useState(authenticated?Cookies.get('auth_companyCode'):'');
  const [companyName, setCompanyName] = useState(authenticated?Cookies.get('auth_companyName'):'');
  const [assetType, setAssetType] = useState('');
  const [assetTypeName, setAssetTypeName] = useState('');
  const [assetSpec, setAssetSpec] = useState('');
  const [assetSpecName, setAssetSpecName] = useState('');

  const [assetGradeHigh, setAssetGradeHigh] = useState(7);  //7이상이면 High
  const [assetGradeRow, setAssetGradeRow] = useState(4); //7이상이면 High
  const [riskGrdHigh, setRiskGrdHigh] = useState(12);  
  const [riskGrdRow, setRiskGrdRow] = useState(9); 
  const [doa, setDoa] = useState(12);    //4이하이면 Row

  const configSetting = {
    companyCode: companyCode,
    companyName: companyName,
    assetType: assetType,
    assetTypeName: assetTypeName,
    assetSpec: assetSpec,
    assetSpecName: assetSpecName,
    setCompanyCode,
    setCompanyName,
    setAssetType,
    setAssetTypeName,
    setAssetSpec,
    setAssetSpecName,
    assetGradeHigh : assetGradeHigh,
    assetGradeRow : assetGradeRow,
    riskGrdHigh : riskGrdHigh,
    riskGrdRow : riskGrdRow,
    doa:doa,
    setAssetGradeHigh,
    setAssetGradeRow,
    setRiskGrdHigh,
    setRiskGrdRow,
    setDoa
  };
  

//   useEffect(() => {
//     const opts = { passive: false, capture: false };
    
//     window.addEventListener('wheel', () => {}, opts);
//     window.addEventListener('touchstart', () => {}, opts);
    
//     return () => {
//         window.removeEventListener('wheel', () => {});
//         window.removeEventListener('touchstart', () => {});
//     }
//   }, []);

  return(
    <AppContext.Provider value={configSetting}>
      <main>
        {authenticated ? (
            <Routes>
              <Route exact path="/" element={<Home />}>
                  <Route path="/dashboard" element={<DashBoard />} />
                  <Route path="/asset" element={<AssetList />} />
                  {/* <Route path="/assetaggrid" element={<AssetList2 />} /> */}
                  <Route path="/template" element={<TemplateList />} />
                  <Route path="/analysis" element={<AnalysisList />} />
                  <Route path="/totalReport" element={<AnalysisListBox />} />
                  <Route path="/compareReport" element={<AnalysisListCompare />} />
                  <Route path="/assetTable" element={<AssetTable />} />
                  <Route path="/log" element={<LogList />} />
                  <Route path="/reports" element={<ReportsList />} />
                  <Route path="/config" element={<ConfigValue />} />
                  <Route path="/login" element={<Home />} />
              </Route>
              <Route path="/asset/upload" element={<AssetUpload />} />
              <Route path="/analysis/create" element={<AnalysisCreate />} />
              <Route path="/analysis/info/:reportId" element={<AnalysisInfo />} />
              <Route path="/analysis/result/:reportId/:resultType" element={<AnalysisResult />} />
              <Route path="/analysis/resultpop/:reportId/:resultType" element={<AnalysisResultPop />} />
              {/* <Route path="/analysis/resultpop/ref/:reportId" element={<AnalysisRefDetail />} /> */}
              <Route path="/analysis/resultpop/ref/:reportId/:resultAssetcd" element={<AnalysisRefDetail />} />
              <Route path="/report/vulnerablity/:reportId" element={<Vulnerablity />} />
              <Route path="/report/riskReport/:reportId" element={<RiskReport />} />
              <Route path="/report/riskManagement/:reportId" element={<RiskManagement />} />
              <Route path="/report/implement/:reportId" element={<ImplementReport />} />
              <Route path="/report/implementResult/:reportId" element={<ImplementResult />} />
              {/* <Route path="/report/assetReport/:reportId/:assetCd/:companyCode/:assetType" element={<AssetReport />} /> */}
              <Route path="/report/assetReport/:reportId/:assetCd/" element={<AssetReport />} />
              <Route path="/report/assetReport/:reportId" element={<AssetReport />} />
              <Route path="/template/info/:reportId" element={<TemplateInfo />} />
              <Route path="/template/create" element={<TemplateCreate />} />
              <Route path="/help/manual" element={<HelpManual />} />
              <Route path="/help/assetCommonCode" element={<HelpAssetCommonCode />} />
              <Route path="/help/RiskhManual" element={<RiskManual />} />
              <Route path="/help/SearchManual" element={<SecureManual />} />
              <Route path="/analysis/AnalysisHtmlx" element={<AnalysisHtmlx />} />
              <Route path="/help/test" element={<Test />} />
            </Routes>
          ) : (
            <Routes>
              <Route path="/accounts/otp/setup" element={<OtpSetup />} />
              <Route exact path="/" element={<Home />}>
                <Route
                      path="/login"
                      element={<LoginForm authenticated={authenticated} />}
                    />
              </Route>
            </Routes>
          )}
      </main>
    </AppContext.Provider>
  );
};

export default App;